import { Slot } from '@radix-ui/react-slot';
import { type ComponentPropsWithRef, type ReactNode } from 'react';

import { Button } from '@repo/ui/Button';
import { usePopover } from '@repo/ui/Popover/PopoverRoot';

export type PopoverCloseProps = ComponentPropsWithRef<'button'> & {
  asChild?: boolean;
  className?: string;
  children?: ReactNode;
};

export const PopoverClose = (props: PopoverCloseProps) => {
  const { asChild, children, ...attrs } = props;
  const { id } = usePopover();

  const Component = asChild ? Slot : Button;

  return (
    <Component popoverTarget={id} {...attrs}>
      {children}
    </Component>
  );
};
